'use client'
import styled from 'styled-components';
import {hardGray, hover, Transition, white} from '@/styles/globalStyleVars'
import Link from "next/link";
import {Img} from "@/components/common/ui/Img";
import reactHtmlParser from "react-html-parser";

const ProjectBox = ({img, title, link, date, cat}) => {
    return (
        <StyledProjectBox className={'single-item-news'}>
            <div className="wrapper">
                <div className='blog-single'>
                    <div className="blog-single__inner">
                        <Link prefetch={true} href={link ? link : '/news-events/slug'}/>
                        <div className="blog-single__inner__img">
                            <Img alt={title} src={img ? img : '/images/dynamic/common/news.jpg'}/>
                        </div>
                        <div className="blog-single__inner__content">
                            <div className="blog-single__inner__content__top">
                                <p>{cat ? cat : 'Blog'}</p>

                                <h4>
                                    {title ? reactHtmlParser(title) : 'Studying Software Development in Australia'}
                                </h4>

                                <p className="date">{date ? reactHtmlParser(date) : 'May 24, 2023'}</p>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </StyledProjectBox>

    )
};


const StyledProjectBox = styled.div`

    .global-image {
        &:after {
            content: "";
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            background: #000;
            opacity: 0.3;
            height: 100%;
            width: 100%;
        }
    }


    .blog-single {
        border: 1px solid ${hardGray};
        border-radius: 10px;
        overflow: hidden;

        &__inner {
            padding-top: calc(460 / 370 * 100%);
            position: relative;
            overflow: hidden;

            a {
                position: absolute;
                inset: 0;
                z-index: 3;
            }

            &__img {
                overflow: hidden;
                position: absolute;
                top: 0;
                right: 0;
                left: 0;
                height: 45%;
                
                .global-image{
                    transition: 0.6s all ${Transition};
                    transform: scale(1.01);
                }
            }

            &__content {

                &__top {

                    bottom: 0;
                    left: 0;
                    right: 0;
                    position: absolute;
                    overflow: hidden;
                    transition: all 0.5s ease-in-out;
                    height: 55%;
                    padding: 20px;

                    p {
                        font-size: 16px;
                        line-height: 20px;
                        letter-spacing: -0.16px;
                        font-weight: 400;
                        color: ${hardGray};
                        margin-bottom: 20px;
                        transition: 0.6s all ${Transition};
                        
                    }

                    h4 {
                        letter-spacing: -0.2px;
                        font-size: 20px;
                        font-weight: 500;
                        line-height: 28px;
                        transition: 0.6s all ${Transition};
                    }
                    .date {
                        font-size: 16px;
                        line-height: 20px;
                        letter-spacing: -0.16px;
                        font-weight: 400;
                        color: ${hardGray};
                        position: absolute;
                        right: 20px;
                        bottom: 0;
                        transition: 0.6s all ${Transition};
                        
                    }

                }


            }

     


            &:hover {
                .blog-single__inner__img{
                    .global-image{
                        transform: scale(1.05);
                    }
                }
                p{
                    color: ${hover};
                    
                }
                h4{
                    color: ${hover};
                }

            }

        }
    }

`;

export default ProjectBox;














